<template>
  <div class="4c">
    <h3 class="uk-margin-medium-top">CALCULA CON TUS INGRESOS Y GASTOS CUÁNDO PUEDES LOGRAR TU SUEÑO</h3>
    <form id="form" class="uk-text-left">

        <h4>LOS SIGUIENTES DATOS SON MENSUALES</h4>

        <div class="uk-margin">
          <label class="uk-inline">INGRESOS TOTALES APROXIMADOS</label><input required type="number" v-model="data['1 Total Ingresos']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>
        
        <hr>

        <div class="uk-margin">
          <label class="uk-inline">GASTOS GENERALES O FAMILIARES</label><input required type="number" v-model="data['Gastos']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>

        <div class="uk-margin">
          <label class="uk-inline">GASTOS O DEUDAS FINANCIERAS</label><input required type="number" v-model="data['Deudas']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>

        <hr>



        <h3>Ahora es tiempo de calcular si puedes lograr tu sueño o meta</h3>


        <div class="uk-margin">
          <label class="uk-inline"  style="font-size: 18px"> Monto que te hace falta para lograrlo</label><input required type="number" v-model="data['4 Monto solicitado']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>

        <div class="uk-margin">
          <label class="uk-inline"  style="font-size: 18px">¿En qué plazo te gustaría pagar este monto?</label>
          <select required  v-model="data['5 Plazo']"  class="uk-select uk-margin-medium-left uk-inline uk-form-width-medium"  >
            
            <option value="6">6</option>
            <option value="12">12</option>
            <option value="18">18</option>
            <option value="24">24</option>
            <option value="36">36</option>
            <option value="60">60 (5 años)</option>
            <option value="120">120 (10 años) </option>
            <option value="180">180 (15 años)</option>
          </select>
        </div>
        <div class="uk-margin">
          <label class="uk-inline"  style="font-size: 18px">¿Cuál es la forma de pago que te conviene?</label>
          <select required  v-model="data['7 Frecuencia Pago']"  class="uk-select uk-margin-medium-left uk-inline uk-form-width-medium" >
            <option value="4">Semanal</option>
            <option value="2">Quincenal</option>
            <option value="1">Mensual</option>
          </select>
        </div>
        

        <hr>


      <div class="uk-margin uk-text-center uk-child-width-1-2@s" uk-grid>
        <div>
<p>Da click al botón para obtener tus resultados:</p>
        </div>
        <div>
<button  class="uk-button uk-button-primary">obtener resultados</button>
        </div>
        
         
      </div>


    </form>




<div id="modal" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
        <h3 class="uk-modal-title">Te ayudaremos a calcular cómo llegar a cumplir tu sueño</h3>


        <form id="modalForm">
          <label >Ingresa tus datos <br></label>
          <input required v-model="data['Nombre']" type="text" class="uk-input" placeholder="Nombre">
          <input required v-model="data['Telefono']" type="tel" class="uk-input" placeholder="Teléfono celular">
          <input v-model="data['Correo']" type="email" class="uk-input" placeholder="Correo">

          <label><input class="uk-checkbox" type="checkbox" required> He leido y acepto los <a class="uk-link-text uk-text-primary" href="#" v-on:click="goTerms">términos y condiciones</a> <br> </label>
    
          <button v-if="!loading" type="submit" class="uk-button uk-button-primary uk-margin">Continuar</button>
          <span v-else uk-spinner></span>
        </form>
        
    </div>
</div>




  </div>
</template>

<script>
export default {
  data: function(){
    return {
      data : {
      },
      plazo : '',
      cuota : 0.0,
      loading : false,
    }
  },
  watch:{
    pago : function(val){
      this.cuota = val
      this.data['6 Cuota a pagar'] = val
    }
  },
  computed:{
    ingresos:function(){
      var ing = this.data['1 Total Ingresos']

      return ing
    },
    gastos:function(){
      
      this.data['2 Total Gastos'] = parseFloat(this.data['Gastos']) + parseFloat(this.data['Deudas'])

      var ing = this.data['2 Total Gastos']


      return ing
    },
    disp:function(){
      var dis = this.ingresos - this.gastos
      if(isNaN(dis)){
        return 0
      }
      this.data['3 Saldo Disponible'] = dis.toFixed(2)
      return (dis.toFixed(2))
    },
    rel:function(){
      var dis = (this.disp) / this.cuota
      // var dis = (this.disp * this.data['Porcentaje']/100) / this.cuota
      if(isNaN(dis)){
        return 0
      }
      dis = dis * 100.0
      this.data['Relación entre cuota y disponible'] = dis.toFixed(2)
      return (dis.toFixed(2))
    },
    
    pago : function() {
      
      try{
        
                var frec = parseFloat(this.data['7 Frecuencia Pago']);
                var plazo = parseFloat(this.data['5 Plazo'])
                var monto = parseFloat(this.data['4 Monto solicitado'])
                var tasa = parseFloat(this.data['Tasa'])



                var principal = monto
                var interest = tasa / 100 / 12;
                var payments = parseFloat(this.data['7 Frecuencia Pago']) * plazo;

                var x = Math.pow(1 + interest, payments);
                var P = (principal*x*interest)/(x-1);

      if(isNaN(P)){
        return 0
      }

      } catch (e) {
        return "Termina de llenar la forma"
      }

      return P.toFixed(2);
    },
    dest:function() {
      // var val = (this.disp * this.data['Porcentaje']/100)
      var val = this.disp
      if(isNaN(val)){
        return 0 
      }
      return val
    }

  },
  beforeDestroy: function(){

    var calif

    switch (true) {
      case this.rel > 200:
        calif = 7
        break;
      case this.rel > 175:
        calif = 6
        break;
      case this.rel > 150:
        calif = 5
        break;
      case this.rel > 130:
        calif = 4
        break;
      case this.rel > 120:
        calif = 3
        break;
      case this.rel > 110:
        calif = 2
        break;
      case this.rel > 100:
        calif = 1
        break;
    
      default:
        calif = 0
        break;
    }


    for(var i in this.data){
      this.$score[i] = this.data[i]
    }

    this.$score['PUNTAJE TOTAL'] = (parseFloat(calif) * 100.0 / 7.0).toFixed(2)
    sessionStorage.setItem('data',JSON.stringify((this.$score)))
  },
  methods:{
      goTerms: function () {
        sessionStorage.setItem('data',JSON.stringify(this.data))
        window.location = 'https://verificagps-89c24.firebaseapp.com/privpol.html'
      },
      go:async function () {
        this.loading = true
        
        this.$score = this.data


        sessionStorage.setItem('data',JSON.stringify(this.$score))


        var date = new Date().getTime()

        sessionStorage.getItem('id') ? date = sessionStorage.getItem('id') : sessionStorage.setItem('id',date)

        UIkit.modal(document.getElementById('modal')).hide()

        this.loading = false

        this.$router.push('result')
      }

  },


  mounted: function(){
    document.getElementById('form').addEventListener('submit',function(e){
      e.preventDefault()
      UIkit.modal(document.getElementById('modal')).show()

    }.bind(this))

    document.getElementById('modalForm').addEventListener('submit',function(e){
      e.preventDefault()
      this.go()
    }.bind(this))

    window.scroll(0,0)
    this.data = JSON.parse(sessionStorage.getItem('data'))
    this.data["Tasa"] = 24
    this.data['Porcentaje'] = 100
    if(Object.keys(this.data).length > 9){
      UIkit.modal(document.getElementById('modal')).show()
    }
  }
    
}
</script>
